import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import WhyUsSection from './components/WhyUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

const HomePage = () => {
  useEffect(() => {
    document.title = 'İzmir Vize Danışmanlık | +10 Yıl Deneyim ve Mutlu Müşteriler';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İzmir Vize Danışmanlık hizmetlerimizle vize sürecinizi doğru yönetin. Deneyimli ekip, iade garantisi, profesyonel evrak takibi ve güvenilir danışmanlık.');
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'izmir vize danışmanlık, karşıyaka vize danışmanlık, vize danışmanlık izmir');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesGrid />
        <WhyUsSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default HomePage;
